import { useEffect } from 'react';
import { useParams, Link  } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetSaleDetailsQuery } from '../slices/salesApiSlice';

const SaleScreen = () => {
  const { id: saleId } = useParams();

  const { data: sale, refetch, isLoading, error } = useGetSaleDetailsQuery(saleId);

  useEffect(() => {
    if (!sale) {
      refetch();
    }
  }, [sale, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Sale {sale?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
                      
              <h2>Customer Details</h2>
              <Message>
              <Link to='/admin/salelist'>Go Back</Link>
              </Message>
              <p>
                <strong>Name: </strong> {sale?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {sale?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {sale?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {sale?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {sale?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Sale Note</h2>
              <p>{sale?.note || 'No additional notes provided'}</p>
              <p>{sale?.username || 'No user name provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Sale Items</h2>
              {sale?.saleItems?.length === 0 ? (
                <Message>This sale has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {sale?.saleItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x D{item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                        <Col md={4}>
                          
                          {((item?.qty || 0) * (item?.price || 0) * 1.4).toFixed(0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Sale Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{sale?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>TotalRev</Col>
                  <Col>D{sale?.totalPrice || 0}</Col>
                </Row>
                <Row>
                  <Col>TotalInsu</Col>
                  <Col>${(sale?.totalInsu || 0).toFixed(0)}</Col>
                  
                </Row>

              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{sale?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SaleScreen;